import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalProps,
  Text,
} from '@ritualco/jutsu'
import { HeraModal } from 'components/HeraModal'
import {
  MerchantListReorder,
  MerchantListReorderProps,
} from 'components/Tables/MerchantListReorder'
import { useContent } from 'lib/content/react'

export type MerchantListReorderModalProps = MerchantListReorderProps &
  Omit<ModalProps, 'children'>

export const MerchantListReorderModal = ({
  merchants,
  onReorder,
  onClose,
  ...modalProps
}: MerchantListReorderModalProps) => {
  const { formatMessage } = useContent()
  return (
    <HeraModal size="4xl" onClose={onClose} {...modalProps}>
      <ModalHeader>
        {formatMessage({ id: 'pmportal.restaurantLists.reorderTitle' })}
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text fontSize="small" color="grayscale.secondary" mb={9}>
          {formatMessage({
            id: 'pmportal.restaurantLists.reorderDescription',
          })}
        </Text>
        <MerchantListReorder merchants={merchants} onReorder={onReorder} />
      </ModalBody>
      <ModalFooter>
        <Button mr={3} onClick={onClose}>
          {formatMessage({ id: 'pmportal.global.actionDone' })}
        </Button>
      </ModalFooter>
    </HeraModal>
  )
}
